import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { map, mergeMap, exhaustMap } from "rxjs/operators";
import { AttributeValueService } from "../../services/attribute-value.service";
import { AttributeValueTypes } from './attribute-value-actions';

@Injectable()
export class AttributeValueEffects {

    loadAttributeValues = createEffect(() =>
        this.actions$.pipe(
            ofType(AttributeValueTypes.InvokeDocumentAttributeValueType),
            // mergeMap((action: any) => {
            exhaustMap((action: any) => {
                return this.attributeValueService.loadDocumentAttributeValues(action.searchtext, action.documentId, action.currentpage, action.pagesize, action.dbname)
                    .pipe(map((data) => ({ type: AttributeValueTypes.RetrieveDocumentAttributeValueType, currentattributevalue: data })));
            })));

    constructor(private actions$: Actions, private attributeValueService: AttributeValueService) { }
}

